import SectionHeading from "./SectionHeading";
import { processSteps } from "@/mocks/columns";

export default function MethodSection() {
  return (
    <section id="method" className="bg-primary-900 text-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="核查流程"
          title="线索如何变成一份结论"
          tone="dark"
          desc="从收到一条线索到公开结论，我们遵循四步可回溯流程，每一步都留档备查。"
        />

        <ol className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <span className="hidden lg:block absolute top-7 left-[12%] right-[12%] border-t border-dashed border-background-50/25"></span>
          {processSteps.map((s) => (
            <li key={s.num} className="relative">
              <div className="rounded-lg bg-background-50/10 backdrop-blur border border-background-50/15 p-6 h-full">
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-accent-500 text-primary-950 font-heading font-black text-xl">
                  {s.num}
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-100/80">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}